export class Tab {

	/**
	 * @param element
	 */
	constructor(element) {
		this.element = element;
		this.tabs = this.element.querySelectorAll('ul.tabs__items li');
		this.contents = this.element.querySelectorAll('div.tabs__content div');
		this.classActive = 'active';
		if (this.tabs.length && this.contents.length) {
			this.removeActiveClass();
			this.addActiveClass(0);
		}
	}

	init() {
		this.addListeners();
	}

	addListeners() {
		for (var index = 0; index < this.tabs.length; index++) {
			this.tabs[index].addEventListener('click',
				this.eventClick.bind(this, index));
		}
	}

	/**
	 * @param activeIndex
	 */
	eventClick(index) {
		this.removeActiveClass();
		this.addActiveClass(index);
	}

	/**
	 * Apend active class
	 * @param activeIndex
	 */
	addActiveClass(activeIndex) {
		this.tabs[activeIndex].className = this.classActive;
		this.contents[activeIndex].className = this.classActive;
		this.contents[activeIndex].style.display = 'block';
	}

	removeActiveClass() {
		for (var index = 0; index < this.tabs.length; index++) {
			this.tabs[index].classList.remove(this.classActive);
			this.contents[index].classList.remove(this.classActive);
			this.contents[index].style.display = 'none';
		}
	}

}
